/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Header from "./header"
import Footer from "./footer"
import HomeBackground from "../components/background/home"

import Theme from "../theme"

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100vw;
  margin: 0 auto;
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Theme>
      <HomeBackground>
        <Header siteTitle={data.site.siteMetadata.title} />
        <Wrapper>
          <div
            style={{
              margin: `0 auto`,
              maxWidth: "990px",
              minHeight: `calc(100vh - 200px)`,
              paddingTop: 0,
              width: `100%`,
            }}
          >
            <main>{children}</main>
          </div>
          <Footer />
        </Wrapper>
      </HomeBackground>
    </Theme>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
